import { BrandedNotification } from '../enums';
export const BRANDED_NOTIFICATION_GET_ADDITIONAL_CATEGORY = `${BrandedNotification.BRANDED_NOTIFICATION}_GET_ADDITIONAL_CATEGORY`;
export const BRANDED_NOTIFICATION_GET_ADDITIONAL_CATEGORY_SUCCESS = `${BrandedNotification.BRANDED_NOTIFICATION}_GET_ADDITIONAL_CATEGORY_SUCCESS`;
export const BRANDED_NOTIFICATION_GET_ADDITIONAL_CATEGORY_FAILURE = `${BrandedNotification.BRANDED_NOTIFICATION}_GET_ADDITIONAL_CATEGORY_FAILURE`;
export const getAdditionalCategoryAction = (payload) => ({
    type: BRANDED_NOTIFICATION_GET_ADDITIONAL_CATEGORY,
    payload: payload
});
export const getAdditionalCategorySuccessAction = (payload) => ({
    type: BRANDED_NOTIFICATION_GET_ADDITIONAL_CATEGORY_SUCCESS,
    payload: payload
});
export const getAdditionalCategoryFailureAction = (payload) => ({
    type: BRANDED_NOTIFICATION_GET_ADDITIONAL_CATEGORY_FAILURE,
    payload: payload
});
//# sourceMappingURL=getAdditionalCategoryAction.js.map